let Fire = {
    name: 'Fire', // mapbox layer id
    displayName: 'Fire',
    value: 1, // change attribution 'a' value
    icon: require('!svg-inline!../controls/ic_whatshot_black_24px.svg'),
};

let Harvest = {
    name: 'Harvest', // mapbox layer id
    displayName: 'Harvest',
    value: 2, // change attribution 'a' value
    icon: require('!svg-inline!../controls/ic_filter_vintage_black_24px.svg'),
};

let Road = {
    name: 'Road', // mapbox layer id
    displayName: 'Infrastructure',
    value: 4, // change attribution 'a' value
    icon: require('!svg-inline!../controls/ic_local_shipping_black_24px.svg'),
};

let Unclassified = {
    name: 'Unclassified', // mapbox layer id
    displayName: 'Untyped',
    value: [5,6,8], // change attribution 'a' value
    icon: require('!svg-inline!../controls/ic_broken_image_black_24px.svg'),
};

let types = [
    Fire,
    Road,
    Harvest,
    Unclassified,
];

export default types;

export let typesObj = {
    '1': Fire,
    '2': Harvest,
    '4': Road,
    '5': Unclassified,
    '6': Unclassified,
    '8': Unclassified,
};

/**
 * return filter value(s) from layer name (array, number, false if not found)
 * @param  {string} name layer name
 * @return {mixed}      layer type value(s)
 */
export function getValuesFromName(name) {
    for (let i = 0, numTypes = types.length; i < numTypes; i++) {
        if (name === types[i].name) {
            return types[i].value;
        }
    }
    return false;
}

/**
 * create an object with each type name as keys, and 0 as values
 * @return {object} "empty" types object
 */
export function getTypesObject() {
    let typesObject = {};
    for (let i = 0, numTypes = types.length; i < numTypes; i++) {
        typesObject[types[i].name] = 0;
    }
    return typesObject;
}



// WEBPACK FOOTER //
// ./src/js/types/types.js